import { render, staticRenderFns } from "./AppointmentTypeRadioCard.vue?vue&type=template&id=34c19bf6"
import script from "./AppointmentTypeRadioCard.vue?vue&type=script&lang=ts"
export * from "./AppointmentTypeRadioCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports